import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const BuildingPlacementSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const placement = report.testFitAnalysis?.buildingPlacement;
  const orientation = report.testFitAnalysis?.dataHallOrientation;
  const hasData = !!(placement || orientation);
  return (
    <SectionShell label={label} hasData={hasData}>
      {placement && <p>{placement}</p>}
      {orientation && (
        <EditorialSubsection theme={theme} label="Data hall orientation">
          {orientation}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
